import { connect } from 'react-redux'
import DialInSettingsStatus from './DialInSettingsStatus'
import { State } from '../../dataStore/reducers/reducerType'
import selectIsLocalParticipantDialedIn from '../../dataStore/selectors/selectIsLocalParticipantDialedIn'
import selectLocalPresentersDialInAudioPublication from '../../dataStore/selectors/selectLocalPresentersDialInAudioPublication'

const mapStateToProps = (state: State) => ({
  isConnected: selectIsLocalParticipantDialedIn(state),
  remoteDialInAudioTrack: selectLocalPresentersDialInAudioPublication(state)
})

export default connect(mapStateToProps)(DialInSettingsStatus)
